import {
  LEAVE_ROLE,
  TOP_ROLE_ID,
  TAB_ROLE_ID,
  MODULE_ROLE_TYPE,
  ROLE_REPLACE_TYPE,
  SEX_TAG
} from './constUtils'
import EXIF from 'exif-js'
import copy from 'copy-to-clipboard'
import { wechatAppId, redirectUrl, apiHost, gsUrl } from '@/env'
// @global: XLSX, saveAs
// 判断当前浏览器是PC端还是移动端
// true：移动端   false：PC端
export const isMobile = (() => {
  let sUserAgent = navigator.userAgent.toLowerCase()
  let bIsMobile = /AppleWebKit.*Mobile/i.test(navigator.userAgent)
  let bIsIpad = sUserAgent.match(/ipad/i) !== null
  let bIsIphoneOs = sUserAgent.match(/iphone os/i) !== null
  let bIsMidp = sUserAgent.match(/midp/i) !== null
  let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) !== null
  let bIsUc = sUserAgent.match(/ucbrowser/i) !== null
  let bIsAndroid = sUserAgent.match(/android/i) !== null
  let bIsCE = sUserAgent.match(/windows ce/i) !== null
  let bIsWM = sUserAgent.match(/windows mobile/i) !== null
  if (
    bIsMobile ||
    bIsIpad ||
    bIsIphoneOs ||
    bIsMidp ||
    bIsUc7 ||
    bIsUc ||
    bIsAndroid ||
    bIsCE ||
    bIsWM
  ) {
    return true
  } else {
    return false
  }
})()

export const IS_ANDROID =
  window.navigator.userAgent.indexOf('Android') > -1 ||
  window.navigator.userAgent.indexOf('Adr') > -1

export const IS_IOS = !!window.navigator.userAgent.match(
  /\(i[^;]+;( U;)? CPU.+Mac OS X/
)

export const IS_WEIXIN = navigator.userAgent.indexOf('MicroMessenger') > 0
export const IS_DING = window.navigator.userAgent.indexOf('DingTalk') > -1

export const getWindowH = () => {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  )
}
/* 缓存操作 */
export const getItem = name => {
  if (window.sessionStorage) {
    let value = window.sessionStorage.getItem(name)
    return window.JSON.parse(value)
  }
  return (window.cache || {})[name]
}

export const setItem = (name, value) => {
  if (window.sessionStorage) {
    return window.sessionStorage.setItem(name, window.JSON.stringify(value))
  }
  ;(window.cache || {})[name] = value
}

export const removeItem = name => {
  if (window.sessionStorage) {
    return window.sessionStorage.removeItem(name)
  }
  ;(window.cache || {})[name] = null
}

/* 缓存操作 */
export const getLocalItem = name => {
  if (window.localStorage) {
    let value = window.localStorage.getItem(name)
    return value === 'undefined' ||
      value === null ||
      value === undefined ||
      value === ''
      ? ''
      : window.JSON.parse(value)
  }
  return (window.cache || {})[name] || ''
}

export const setLocalItem = (name, value) => {
  if (window.localStorage) {
    return window.localStorage.setItem(name, window.JSON.stringify(value))
  }
  ;(window.cache || {})[name] = value
}

export const removeLocalItem = name => {
  if (window.localStorage) {
    return window.localStorage.removeItem(name)
  }
  ;(window.cache || {})[name] = null
}

// 获取URL search对象
export const getSearchObj = (searchStr, index = 1) => {
  let _obj = {}
  let _search = searchStr || window.location.search || ''

  if (_search) {
    _search = (searchStr ? searchStr.substr(index) : _search.substr(1))
      .replace(/&/g, '", "')
      .replace(/=/g, '": "')
    _search = JSON.parse(`{"${_search}"}`)
    _obj = _search
  }
  return _obj
}

// 获取URL searchKey的值
export const getSearchValueByKey = (key, search = '') => {
  let _value = ''
  let _search = search || window.location.search
  let _startIndex = _search.search(key)
  if (_startIndex !== -1) {
    _startIndex = _startIndex + key.length + 1
    let _endIndex = _search.indexOf('&', _startIndex)
    if (_endIndex !== -1) {
      _value = _search.slice(_startIndex, _endIndex)
    } else {
      _value = _search.slice(_startIndex)
    }
  }
  return _value
}

export const getTokenUrl = () => {
  let url = window.location.href
  let hashIndex = url.indexOf('#')
  if (hashIndex === -1) {
    hashIndex = url.length
  }
  return url.substring(0, hashIndex)
}

export const isEmpty = (val, validateNullStr = false) =>
  val === undefined ||
  val === null ||
  val === '' ||
  (validateNullStr && val === 'null') ||
  (Array.isArray(val) && !val.length)

/**
 * 字数限制过滤器
 * @param str 需要过滤的字符串
 * @param num 限制的位数
 */
export const charFilter = (str, num) => {
  let result = ''
  if (!str) {
    result = ''
  } else {
    if (str.length > num) {
      result = str.slice(0, num - 1) + '...'
    } else {
      result = str
    }
  }
  return result
}

/**
 * 时间格式转换 YYYY-MM-DD hh:mm:ss 自由组合
 * @param date 时间对象
 * @param type 返回时间格式
 */
export const timeFormat = (dateObj, type) => {
  if (!(dateObj instanceof Date)) {
    throw new Error('参数dateObj不是Date实例')
  }
  let _timeString = type || 'YYYY-MM-DD'
  let _typeObj = {
    YYYY: dateObj.getFullYear(),
    MM: ('00' + (dateObj.getMonth() + 1)).slice(-2),
    DD: ('00' + dateObj.getDate()).slice(-2),
    hh: ('00' + dateObj.getHours()).slice(-2),
    mm: ('00' + dateObj.getMinutes()).slice(-2),
    ss: ('00' + dateObj.getSeconds()).slice(-2)
  }
  Object.keys(_typeObj).forEach(key => {
    _timeString = _timeString.replace(key, _typeObj[key])
  })
  return _timeString
}
/**
 *
 * @param {*} startDate
 * @param {*} endDate
 * @param {*} dayLength
 * @returns
 */
export const getDateStr = (startDate, endDate, dayLength = 0) => {
  var str = startDate
  for (var i = 0; ; i++) {
    var getDate = getTargetDate(startDate, dayLength)
    startDate = getDate
    if (getDate <= endDate) {
      str += ',' + getDate
    } else {
      break
    }
  }
  return str
}

// startDate: 开始时间；dayLength：每隔几天，0-代表获取每天，1-代表日期间隔一天
const getTargetDate = (date, dayLength) => {
  dayLength = dayLength + 1
  var tempDate = new Date(date)
  tempDate.setDate(tempDate.getDate() + dayLength)
  var year = tempDate.getFullYear()
  var month =
    tempDate.getMonth() + 1 < 10
      ? '0' + (tempDate.getMonth() + 1)
      : tempDate.getMonth() + 1
  var day =
    tempDate.getDate() < 10 ? '0' + tempDate.getDate() : tempDate.getDate()
  return year + '-' + month + '-' + day
}

/**
 *
 * 获取某年某月的最后一天
 * @param (year, month) // 月统计所在的年、月
 */
export const monthLastDay = (year, month) => {
  let _nextMonth = +new Date(+year, +month, 1) - 86400000
  let _day = timeFormat(new Date(+_nextMonth), 'YYYY-MM-DD').replace(/-/gi, '')
  return _day
}

/**
 *
 * 获取今天30分钟后的时间 过天取整 四舍五入
 *  22:53 => 22:55 22:59 => 23:00 23:58 => 23:59
 */
export const minutesLater = () => {
  const _dateNow = timeFormat(new Date(), 'YYYY/MM/DD')
  const _timeNow = ~~(new Date().getTime() / 1000) * 1000
  const _dateTomorrow = timeFormat(
    new Date(new Date(_dateNow).getTime() + 86400000),
    'YYYY/MM/DD'
  )
  const _timeTomorrow = new Date(_dateTomorrow).getTime()
  let _hour = 0
  let _minute = 0
  if (_timeTomorrow - _timeNow > 1800000) {
    const _time = timeFormat(new Date(_timeNow + 1800000), 'hh:mm')
    const _timeArr = _time.split(':')
    const _timeMinuteArr = _timeArr[1].split('')
    _hour = _timeArr[0]
    _minute = _timeArr[1]
    if (+_minute === 0) {
    } else if (+_minute < 55) {
      if (+_timeMinuteArr[1] <= 5) {
        _minute = `${_timeMinuteArr[0]}5`
      } else {
        _minute = `${+_timeMinuteArr[0] + 1}0`
      }
    } else {
      if (_hour < 23) {
        _hour = `00${+_hour + 1}`.slice(-2)
        _minute = `00`
      } else {
        _hour = `23`
        _minute = `59`
      }
    }
  } else {
    _hour = `23`
    _minute = `59`
  }
  return [_hour, _minute]
}

/**
 * 用于月统计---获取月末时间
 * 如果月份已过，为月末；如果为当月，获取昨天时间；如果为未来月，则为1号。  YYYYMMDD
 * @param (year, month) // 月统计所在的年、月
 */
export const monthDay = (year, month) => {
  let _yesterday = +new Date() - 86400000
  let _now = timeFormat(new Date(), 'YYYY-MM-DD').split('-')
  let _yearNow = _now[0]
  let _monthNow = _now[1]
  // 已过月份
  let _passedMonth =
    +year < +_yearNow || (+year === +_yearNow && +month < +_monthNow)
  // 当前月
  let _thisMonth = +year === +_yearNow && +month === +_monthNow
  // 未来月
  let _futureMonth =
    +year > +_yearNow || (+year === +_yearNow && +month > +_monthNow)
  let _day = _now
  if (_passedMonth) {
    _day = monthLastDay(year, month)
  } else if (_thisMonth) {
    if (+_now[2] === 1) {
      // 当月第一天
      _day = `${year}${month}01`
    } else {
      // 当月其它天
      _day = timeFormat(new Date(+_yesterday), 'YYYY-MM-DD').replace(/-/gi, '')
    }
    // 获取昨天日期
  } else if (_futureMonth) {
    _day = `${year}${month}01`
  }
  // alert(
  //   `${_yesterday} ${_now} ${_yearNow} ${_monthNow} ${_passedMonth} ${_thisMonth} ${_futureMonth}`
  // )
  return _day
}
/**
 * 年月日任何规格，返回对应数组【年，月（，日）】
 * @param (dateStr) // 任意格式的时间字符串 可为年月日/年月/年 可加分隔符
 * @return ["20190929", "2019", "09", "29", index: 0, input: "201909290000", groups: undefined]
 */
export const toDateArr = dateStr => {
  // 为方便提取年月日通用补全0000
  let _day = `${dateStr}0000`
    .replace(/[^ \d]/gi, '')
    .match(/(\d{4})(\d{2})(\d{2})/)
  return _day
}

/**
 * @description 日期补 0
 * @param {Number|String} day 8
 * @return {String}  08
 */
export function dateZeroFill(day) {
  if (!day) return ''
  day = `${day}`
  if (day.length >= 2) return day
  return `00${day}`.slice(-2)
}

/**
 * @description 根据日期列表数组和格式 返回对应格式的时间
 * @param {Array} dateList [ 年-月-日 ]
 * @param {String} format 任意格式
 * @return {String} 对应格式的时间
 */
export function toDateFormat(dateList = [], format = 'yyyy-MM-dd') {
  let _formatMap = {
    0: 'y',
    1: 'm',
    2: 'd'
  }
  dateList.forEach((value, index) => {
    value = dateZeroFill(value)
    format = format.replace(new RegExp(`${_formatMap[index]}+`, 'i'), value)
  })
  return format
}

/**
 * 字符串 20200814
 * @param dateNum 时间数字
 * @param type 返回时间格式
 */
export const dateToTime = (dateNum, type) => {
  if (!dateNum) {
    return ''
  }
  let _timeString = type || '-'
  let _toDateArr = toDateArr(`${dateNum}`)
  _toDateArr.shift()
  return _toDateArr.join(_timeString)
}

/**
 * 只显示名字末尾两个字
 * @param (name) // 名字字符串
 * @return **
 */
//
export const nameLastTwoWords = name => {
  if (!name || typeof name !== 'string') {
    return ''
  }
  return name.replace(/^(.*)(.{2})$/, '$2')
}

// 防抖函数：调用后在一定的时间内函数不执行，过了限时执行，在限时内再次调用会重新开启定时器
export const debounce = (fn, wait = 300) => {
  // eslint-disable-next-line space-before-function-paren
  return function () {
    let context = this
    let args = arguments
    if (fn.timeout) clearTimeout(fn.timeout)
    fn.timeout = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}

// 截流函数：每一个时间限制内会执行一次
export const throttle = (fn, wait = 600) => {
  // eslint-disable-next-line space-before-function-paren
  return function () {
    let context = this
    let args = arguments
    if (!fn.timeout) {
      fn.apply(context, args)
      fn.timeout = setTimeout(() => {
        fn.timeout = null
      }, wait)
    }
  }
}

/**
 * Excel导入转Json格式
 * @param {File} file 文件对象
 * @param {number} startRow 数据读取开始行数，起始为1
 * @param {object} keyNams Excel列名与Json对象属性名转换对象
 */
export const importExcelToJson = (file, startRow, keyNams) => {
  return new Promise((resolve, reject) => {
    let wb
    let reader = new FileReader()
    let rABS = !!reader.readAsBinaryString
    // eslint-disable-next-line space-before-function-paren
    reader.onload = function (e) {
      var data = e.target.result
      if (rABS) {
        wb = window.XLSX.read(data, { type: 'binary' })
      } else {
        // for IE
        wb = window.XLSX.read(new Uint8Array(data), {
          type: 'array'
        })
      }
      let _data = wb.Sheets[wb.SheetNames[0]]
      if (startRow) {
        let _ref = _data['!ref'].split(':')
        _ref[0] = 'A' + startRow
        _data['!ref'] = _ref.join(':')
      }
      // wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
      // wb.Sheets[Sheet名]获取第一个Sheet的数据
      _data = window.XLSX.utils.sheet_to_json(_data)
      let _result = []
      let _keys = Object.keys(keyNams)
      _data.forEach(item => {
        let _item = {}
        _keys.forEach(key => {
          _item[keyNams[key]] = item[key]
        })
        _result.push(_item)
      })
      resolve(_result)
    }
    if (rABS) {
      reader.readAsBinaryString(file)
    } else {
      reader.readAsArrayBuffer(file)
    }
  })
}

/**
 * Json格式转Excel文件导出
 * @param {object} data Json数据对象
 * @param {object} keyNams Json对象属性名与Excel列名转换对象
 * @param {string} fileName 导出文件名
 * @param {string} sheetName 导出sheet名
 * @param {array} comments 导出文件说明内容
 */
export const exportJsonToExl = (
  data,
  keyNams,
  fileName,
  sheetName,
  comments
) => {
  let exportKeys = Object.keys(keyNams)
  let keyNamesRow = JSON.parse(JSON.stringify(keyNams))
  data.unshift(keyNamesRow)
  comments.reverse().forEach(item => {
    data.unshift(item)
  })
  let content = {}

  // 把json格式的数据转为excel的行列形式
  let sheetsData = data
    // eslint-disable-next-line space-before-function-paren
    .map(function (item, rowIndex) {
      if (typeof item !== 'object') {
        return [
          Object.assign(
            {},
            {
              value: item,
              position: String.fromCharCode(65 + 0) + (rowIndex + 1)
            }
          )
        ]
      } else {
        // eslint-disable-next-line space-before-function-paren
        return exportKeys.map(function (key, columnIndex) {
          return Object.assign(
            {},
            {
              value: item[key] || '',
              position:
                (columnIndex > 25
                  ? methofGetCharCol(columnIndex)
                  : String.fromCharCode(65 + columnIndex)) +
                (rowIndex + 1)
            }
          )
        })
      }
    })
    // eslint-disable-next-line space-before-function-paren
    .reduce(function (prev, next) {
      return prev.concat(next)
    })
  // eslint-disable-next-line space-before-function-paren
  sheetsData.forEach(function (item, index) {
    content[item.position] = { v: item.value }
  })

  // 设置区域,比如表格从A1到D10,SheetNames:标题，
  let coordinate = Object.keys(content)
  let sheets = {}
  sheets[sheetName] = Object.assign({}, content, {
    '!ref': coordinate[0] + ':' + coordinate[coordinate.length - 1]
  })
  let workBook = {
    SheetNames: [sheetName],
    Sheets: sheets
  }
  // 这里的数据是用来定义导出的格式类型
  let excelData = window.XLSX.write(workBook, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  })
  let blob = new Blob([methodString2ArrayBuffer(excelData)], { type: '' })
  window.saveAs(blob, `${fileName}.xlsx`)

  // 字符串转字符流
  function methodString2ArrayBuffer(s) {
    let buf = new ArrayBuffer(s.length)
    let view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }
  // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
  function methofGetCharCol(n) {
    let s = ''
    let m = 0
    while (n > 0) {
      m = (n % 26) + 1
      s = String.fromCharCode(m + 64) + s
      n = (n - m) / 26
    }
    return s
  }
}

// base64转文件
export const dataURLtoFile = (dataurl, filename = 'file') => {
  // base64转化为file对象 方便上传
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
}

export const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = e => {
      resolve(e.target.result)
    }
    reader.readAsDataURL(file)
  })
}
export const fileToBlob = file => {
  return new Promise((resolve, reject) => {
    fileToBase64(file)
      .then(base64 => resolve(new Blob([base64], { type: file.type })))
      .catch(err => {
        console.log('unhandledrejection', err)
      })
  })
}

/**
 * 图像压缩
 * @param {File} imgFile 图片文件对象
 * @return {object}
 *            base64Url  Base64Url
 *            blob       Blob
 */
export const miniImage = (imgFile, type, rate = 0.8) => {
  return new Promise((resolve, reject) => {
    try {
      let orientation
      if (!type) {
        EXIF.getData(imgFile, function () {
          orientation = EXIF.getTag(imgFile, 'Orientation')
        })
      }

      let reader = new FileReader()
      reader.onload = () => {
        let img = new Image()
        img.src = reader.result
        img.onload = () => {
          let drawWidth = img.naturalWidth
          let drawHeight = img.naturalHeight

          let degree = 0
          let width
          let height
          // 图片大小小于1M时不进行压缩
          if (imgFile.size > 1024 * 1024 || +rate !== 0.8) {
            let maxSide = Math.max(drawWidth, drawHeight)
            let minSide = Math.min(drawWidth, drawHeight)
            if (maxSide > 1024) {
              minSide = (minSide / maxSide) * 1024
              maxSide = 1024
              if (drawWidth > drawHeight) {
                drawWidth = maxSide
                drawHeight = minSide
              } else {
                drawWidth = minSide
                drawHeight = maxSide
              }
            }
          }
          let canvas = document.createElement('canvas')
          canvas.width = drawWidth
          width = drawWidth
          canvas.height = drawHeight
          height = drawHeight
          let context = canvas.getContext('2d')
          // 判断图片方向，重置canvas大小，确定旋转角度，iphone默认的是home键在右方的横屏拍摄方式
          if (!type) {
            switch (orientation) {
              // iphone横屏拍摄，此时home键在左侧
              case 3:
                degree = 180
                drawWidth = -width
                drawHeight = -height
                break
              // iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)
              case 6:
                canvas.width = height
                canvas.height = width
                degree = 90
                drawWidth = width
                drawHeight = -height
                break
              // iphone竖屏拍摄，此时home键在上方
              case 8:
                canvas.width = height
                canvas.height = width
                degree = 270
                drawWidth = -width
                drawHeight = height
                break
            }
          }
          // 使用canvas旋转校正
          context.rotate((degree * Math.PI) / 180)
          context.drawImage(img, 0, 0, drawWidth, drawHeight)
          let _base64Url = canvas.toDataURL('image/png', rate)
          let _blob = convertBase64UrlToBlob(_base64Url)
          resolve({
            width: drawWidth,
            height: drawHeight,
            base64Url: _base64Url,
            blob: _blob
          })
        }
      }
      reader.readAsDataURL(imgFile)
    } catch (err) {
      reject(err)
    }
  })
}

export function prepareCanvas(cvs, ctx, w, h, orientation) {
  cvs.width = w
  cvs.height = h
  // 判断图片方向，重置canvas大小，确定旋转角度，iphone默认的是home键在右方的横屏拍摄方式
  let degree = 0
  switch (orientation) {
    case 3:
      // iphone横屏拍摄，此时home键在左侧
      degree = 180
      w = -w
      h = -h
      break
    case 6:
      // iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)
      cvs.width = h
      cvs.height = w
      degree = 90
      // w = w;
      h = -h
      break
    case 8:
      // iphone竖屏拍摄，此时home键在上方
      cvs.width = h
      cvs.height = w
      degree = 270
      w = -w
      // h = h;
      break
  }
  // 使用canvas旋转校正
  ctx.rotate((degree * Math.PI) / 180)
  return { w, h }
}

/**
 * 图像压缩
 * @param {File} imgFile 图片文件对象
 * @return {object}
 *            base64Url  Base64Url
 *            blob       Blob
 */
// 压缩图片时 质量减少的值
const COMPRESS_QUALITY_STEP = 0.03
const COMPRESS_QUALITY_STEP_BIG = 0.06
// 压缩图片时，图片尺寸缩放的比例，eg：0.9, 等比例缩放为0.9
const COMPRESS_SIZE_RATE = 0.9
export const miniImageNew = (
  imgFile,
  maxSize = 1024 * 1024,
  fileType = 'png',
  minSize = 0
) => {
  return new Promise((resolve, reject) => {
    try {
      EXIF.getData(imgFile, () => {
        let orientation = EXIF.getTag(imgFile, 'Orientation')
        let reader = new FileReader()
        reader.onload = () => {
          let image = new Image()
          image.src = reader.result
          image.onload = () => {
            let fillBgColor = '#ffffff'
            let maxWidth = 1280
            let maxHeight = 1280
            let cvs = document.createElement('canvas')
            let w = image.width
            let h = image.height
            let quality = 0.9

            /**
             * 这里用于计算画布的宽高
             */
            if (w > 0 && h > 0) {
              if (w / h >= maxWidth / maxHeight) {
                if (w > maxWidth) {
                  h = (h * maxWidth) / w
                  w = maxWidth
                }
              } else {
                if (h > maxHeight) {
                  w = (w * maxHeight) / h
                  h = maxHeight
                }
              }
            }

            let ctx = cvs.getContext('2d')
            let size = prepareCanvas(cvs, ctx, w, h, orientation)

            // 填充白色背景
            ctx.fillStyle = fillBgColor
            ctx.fillRect(0, 0, size.w, size.h)

            // 将图片绘制到Canvas上，从原点0,0绘制到w,h
            ctx.drawImage(image, 0, 0, size.w, size.h)

            let _base64Url = cvs.toDataURL(`image/${fileType}`, quality)

            // 当图片大小 > maxSize 时，循环压缩,并且循环不超过5次
            let count = 0
            while (_base64Url.length > maxSize && count < 10) {
              let imgDataLength = _base64Url.length
              let isDoubleSize = imgDataLength / maxSize > 2

              // 质量一次下降
              quality -= isDoubleSize
                ? COMPRESS_QUALITY_STEP_BIG
                : COMPRESS_QUALITY_STEP
              quality = parseFloat(quality.toFixed(2))

              // 图片还太大的情况下，继续压缩 。 按比例缩放尺寸
              let scaleStrength = COMPRESS_SIZE_RATE
              w = w * scaleStrength
              h = h * scaleStrength

              size = prepareCanvas(cvs, ctx, w, h, orientation)

              // 将图片绘制到Canvas上，从原点0,0绘制到w,h
              ctx.drawImage(image, 0, 0, size.w, size.h)

              _base64Url = cvs.toDataURL(`image/jpeg`, quality)
              count++
            }

            cvs = ctx = null
            // 如果配置了自定义大小 优先使用 base64是预览使用 最终上传使用blob或者file
            const limitMinSize = !!(minSize && imgFile.size <= minSize)
            resolve({
              blob: limitMinSize ? imgFile : convertBase64UrlToBlob(_base64Url),
              base64: _base64Url,
              file: limitMinSize ? imgFile : dataURLtoFile(_base64Url)
            })
          }
        }
        reader.readAsDataURL(imgFile)
      })
    } catch (err) {
      reject(err)
    }
  })
}

/**
 * Base64Url转Blob
 * @param {string} urlData Base64Url
 * @return Blob
 */
export const convertBase64UrlToBlob = urlData => {
  // convertBase64UrlToBlob函数是将base64编码转换为Blob
  // 去掉url的头，并转换为byte
  var bytes = window.atob(urlData.split(',')[1])
  // 处理异常,将ascii码小于0的转换为大于0
  var ab = new window.ArrayBuffer(bytes.length)
  var ia = new window.Uint8Array(ab)
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new window.Blob([ab], { type: 'image/png' })
}

const _getQueryString = name => {
  let _href = window.location.href
  let _searchIndex = _href.indexOf('?')
  let _hashIndex = _href.indexOf('#')
  if (_searchIndex === -1) {
    return null
  }
  /* 截取 ? 到 # 之间的参数 */
  let _search =
    _hashIndex > -1
      ? _href.substring(_searchIndex + 1, _hashIndex)
      : _href.substring(_searchIndex + 1)
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = _search.match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/* url 参数操作 */
export const getQueryString = _getQueryString

export const getCorpId = () => {
  let _corpId = _getQueryString('corpId')
  // 如果获取的企业ID携带hash值 则去除
  if (_corpId && _corpId.indexOf('#') !== -1) {
    _corpId = _corpId.substring(0, _corpId.indexOf('#'))
  }
  return _corpId
}

const _preventDefault = e => {
  e.preventDefault && e.preventDefault()
  e.stopPropagation && e.stopPropagation()
  return false
}

// 禁止页面滚动
export const disableTouchMove = () => {
  document.addEventListener('touchmove', _preventDefault, {
    capture: false,
    passive: false
  })
}

// 恢复页面滚动
export const enableTouchMove = () => {
  document.removeEventListener('touchmove', _preventDefault, {
    capture: false,
    passive: false
  })
}

// 禁止页面滚动（DOM）
export const disableTouchMoveByDom = (ele, top) => {
  if (!ele) {
    return false
  }
  ele.style.position = 'fixed'
  ele.style.top = `-${top}px` || 0
}

// 恢复页面滚动（DOM）
export const enableTouchMoveByDom = (ele, top) => {
  if (!ele) {
    return false
  }
  ele.style.position = ''
  window.scrollTo(0, top)
}

export const transformDaysForm = day => {
  if (!day) {
    return ''
  }
  let _dayArray = day.split('').sort((a, b) => {
    return a > b
  })
  let _initString = _dayArray.some(value => {
    return value > 0 && value < 7
  })
    ? '周'
    : ''
  let _resultDay = _dayArray.reduce((total, item) => {
    switch (item) {
      case '1':
        total = total + '一、'
        break
      case '2':
        total = total + '二、'
        break
      case '3':
        total = total + '三、'
        break
      case '4':
        total = total + '四、'
        break
      case '5':
        total = total + '五、'
        break
      case '6':
        total = total + '六、'
        break
      case '7':
        total = total + '日、'
        break
      case '8':
        total = total + '假期、'
        break
      default:
        break
    }
    return total
  }, _initString)
  _resultDay = _resultDay.substring(0, _resultDay.length - 1)
  return _resultDay
}

// 是否是住宿标签
export const isDormTag = tag => {
  if (!tag || typeof tag !== 'string') {
    return false
  }
  tag = tag.replace(/\s+/gi, '')
  if (!tag) {
    return false
  }
  return tag.indexOf('住宿') > -1
}

// 计算按天请假时间
export const unitDayTime = (startTime, endTime, format = 'YYYY-MM-DD hhmm') => {
  let _segment = ['上午', '下午']
  let _startTime = timeFormat(new Date(+startTime), format).split(' ')
  let _endTime = timeFormat(new Date(+endTime), format).split(' ')
  if (_startTime[1] >= 1200) {
    _segment[0] = '下午'
  }
  if (_endTime[1] < 1200) {
    _segment[1] = '上午'
  }
  return [`${_startTime[0]} ${_segment[0]}`, `${_endTime[0]} ${_segment[1]}`]
}

/**
 * 深拷贝
 * @param {*} obj 拷贝对象
 * @param {*} cache 缓存数组
 */
const typeMap = '[object Map]'
const typeSet = '[object Set]'
const typeArray = '[object Array]'
const typeObject = '[object Object]'
// 非原始类型的 不可遍历类型  Date RegExp Function
const typeDate = '[object Date]'
const typeRegExp = '[object RegExp]'
const typeFunction = '[object Function]'

// 非原始类型的 不可遍历类型的 集合（原始类型已经被过滤了不用再考虑了）
const simpleType = [typeDate, typeRegExp, typeFunction]

// 判断是否为引用类型
const isObject = obj => {
  if (obj === null) {
    return false
  } else {
    return typeof obj === 'function' || typeof obj === 'object'
  }
}
// 获取标准类型
const getType = target => {
  return Object.prototype.toString.call(target)
}

export const deepCopy = (obj, map = new WeakMap()) => {
  if (!isObject(obj)) {
    return obj
  }
  // 获取 实际类型
  const objType = getType(obj)
  // 判断是否为可遍历类型
  if (simpleType.includes(objType)) {
    switch (objType) {
      case typeDate:
        return new Date(obj)
      case typeRegExp:
        // 正则
        const reg = /\w*$/
        const result = new RegExp(obj.source, reg.exec(obj)[0])
        result.lastIndex = obj.lastIndex // lastIndex 表示每次匹配时的开始位置
        return result
      default:
        return obj
    }
  }
  // 处理循环引用
  if (map.get(obj)) {
    return map.get(obj)
  }
  let cloneTarget
  // 处理可遍历类型
  switch (objType) {
    case typeSet:
      // Set
      cloneTarget = new Set()
      map.set(obj, cloneTarget)
      obj.forEach(item => {
        cloneTarget.add(deepCopy(item, map))
      })
      return cloneTarget
    case typeMap:
      // Map
      cloneTarget = new Map()
      map.set(obj, cloneTarget)
      obj.forEach((value, key) => {
        cloneTarget.set(key, deepCopy(value, map))
      })
      return cloneTarget
    case typeArray:
      // 数组
      cloneTarget = []
      map.set(obj, cloneTarget)
      obj.forEach((item, index) => {
        cloneTarget[index] = deepCopy(item, map)
      })
      return cloneTarget
    case typeObject:
      // 对象
      cloneTarget = {}
      map.set(obj, cloneTarget)
      const arr = [...Object.keys(obj), ...Object.getOwnPropertySymbols(obj)]
      arr.forEach(item => {
        cloneTarget[item] = deepCopy(obj[item], map)
      })
      return cloneTarget
    default:
      return obj
  }
}

export const EScroll = ({
  minMove = 0,
  dom,
  start,
  move,
  end,
  stop = true,
  horizental = true
} = {}) => {
  const tool = {
    getSlideAngle(dx, dy) {
      return (Math.atan2(dy, dx) * 180) / Math.PI
    },
    getSlideDirection(startX, startY, endX, endY) {
      // 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      var dy = startY - endY
      var dx = endX - startX
      var result = 0
      // 如果滑动距离太短
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        return result
      }
      var angle = tool.getSlideAngle(dx, dy)
      if (angle >= -45 && angle < 45) {
        result = 3
      } else if (angle >= 45 && angle < 135) {
        result = 2
      } else if (angle >= -135 && angle < -45) {
        result = 1
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 4
      }
      return result
    },
    getSlideValidity(horizental, direction) {
      // 角度没有更改 直接返回
      if (!direction) {
        return false
      }
      // 预设滑动方向和实际方向不一样 就忽略掉
      return (horizental && direction > 2) || (!horizental && direction < 3)
    }
  }
  const f = {
    data: {},
    start(e) {
      // 手指触碰的屏幕就会触发(一次)
      stop && e.preventDefault() // 阻止冒泡，当stop为false的时候就运行冒泡，默认为true
      f.data = {
        // 储存的是一些数据
        ...f.data, // 扩展运算，将之前的数据进行合并
        x: Math.ceil(e.touches[0].pageX), // 手指开始的横向位置
        y: Math.ceil(e.touches[0].pageY), // 手指开始的纵向位置
        ex: 0, // 手指结束的横向位置
        ey: 0, // 手指结束的纵向位置
        time: new Date().getTime() // 手指的开始时间
      }
      start && start(f.data) // 执行自定义的 start 方法
    },
    move(e) {
      // 多次
      stop && e.preventDefault() // 阻止冒泡，当stop为false的时候就运行冒泡，默认为true
      f.data = {
        // 储存的是一些数据
        ...f.data, // 扩展运算，将之前的数据进行合并
        ex: Math.ceil(e.touches[0].pageX), // 手指结束的横向位置
        ey: Math.ceil(e.touches[0].pageY) // 手指结束的纵向位置
      }
      // 获取滑动角度 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      let direction = tool.getSlideDirection(
        f.data.x,
        f.data.y,
        f.data.ex,
        f.data.ey
      )
      // 判断是否通过滑动验证
      if (tool.getSlideValidity(horizental, direction)) {
        // 通过校验 更新最后一次合法数据
        f.data = {
          ...f.data,
          lx: f.data.ex,
          ly: f.data.ey
        }
        move &&
          move({
            // 执行自定义的 move方法，并且把得到的数据进行返回
            x: Math.ceil(e.touches[0].pageX), // 手指开始的横向位置
            y: Math.ceil(e.touches[0].pageY), // 手指开始的纵向位置
            dx: f.data.ex - f.data.x, // 手指在屏幕上的横向的移动距离
            dy: f.data.ey - f.data.y, // 手指在屏幕上的纵向的移动距离
            direction // 滑动方向
          })
      }
    },
    end(e) {
      // 手指离开屏幕就会触发(一次)
      stop && e.preventDefault() // 阻止冒泡，当stop为false的时候就运行冒泡，默认为true
      // 获取滑动角度 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      let direction = tool.getSlideDirection(
        f.data.x,
        f.data.y,
        f.data.ex,
        f.data.ey
      )
      // 判断是否通过滑动验证 不通过校验 使用最后一次合法数据
      let valid = tool.getSlideValidity(horizental, direction)
      let time = new Date().getTime() // 手指离开的时间
      let params = {
        // 执行自定义的 end 方法，并且把得到的数据进行返回
        time, // 当前时间
        startTime: f.data.time, // 手指的开始时间
        dt: time - f.data.time, // 手指在屏幕逗留的时间差 ms
        dy: (valid ? f.data.ey || f.data.y : f.data.ly || f.data.y) - f.data.y, // 手指在屏幕上的纵向的移动距离
        dx: (valid ? f.data.ex || f.data.x : f.data.lx || f.data.x) - f.data.x, // 手指在屏幕上的横向的移动距离
        direction // 滑动方向
      }
      end && end(Object.assign({}, params))
      f.data = {}
    }
  }
  // 这里是防止dom元素绑定事件异常，导致整体页面无法正常往下执行
  try {
    dom.removeEventListener('touchstart', f.start)
    dom.addEventListener('touchstart', f.start)
    dom.removeEventListener('touchmove', f.move)
    dom.addEventListener('touchmove', f.move)
    dom.removeEventListener('touchend', f.end)
    dom.addEventListener('touchend', f.end)
  } catch (e) {
    console.error('给dom元素绑定事件的时候出现了错误', e)
  }
  return {
    destroy() {
      dom.removeEventListener('touchstart', f.start)
      dom.removeEventListener('touchmove', f.move)
      dom.removeEventListener('touchend', f.end)
    }
  }
}

// 搜索debounce
export const searchDebounce = (t, func, wait) => {
  // eslint-disable-next-line space-before-function-paren
  return function () {
    let context = this
    let args = arguments
    if (t.timeout) clearTimeout(t.timeout)
    t.timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

// 阿拉伯数转中文
export const numToCn = num => {
  var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
  var unitPos = 0
  var strIns = ''
  var chnStr = ''
  var needZero = false

  if (num === 0) {
    return chnNumChar[0]
  }

  let SectionToChinese = section => {
    var chnNumChar = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九'
    ]
    var chnUnitChar = ['', '十', '百', '千']
    var strIns = ''
    var chnStr = ''
    var unitPos = 0
    var zero = true
    while (section > 0) {
      var v = section % 10
      if (v === 0) {
        if (!zero) {
          zero = true
          chnStr = chnNumChar[v] + chnStr
        }
      } else {
        zero = false
        strIns = chnNumChar[v]
        strIns += chnUnitChar[unitPos]
        chnStr = strIns + chnStr
      }
      unitPos++
      section = Math.floor(section / 10)
    }
    return chnStr
  }

  while (num > 0) {
    var section = num % 10000
    if (needZero) {
      chnStr = chnNumChar[0] + chnStr
    }
    strIns = SectionToChinese(section)
    strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0]
    chnStr = strIns + chnStr
    needZero = section < 1000 && section > 0
    num = Math.floor(num / 10000)
    unitPos++
  }

  return chnStr
}

export const timeStrToDate = timeStr => {
  return new Date(
    `${timeStr.substring(0, 4)}/${timeStr.substring(4, 6)}/${timeStr.substring(
      6,
      8
    )}`
  )
}

export const getWeekRange = date => {
  const _date = new Date(date)
  // 获取当前日期是星期几（0 表示星期日，1 表示星期一，... 6 表示星期六）
  const day = _date.getDay()
  // 将星期天调整为 7（方便以星期一作为起始日）
  const adjustedDay = day === 0 ? 7 : day
  // 计算本周的星期一
  const monday = new Date(_date)
  monday.setDate(_date.getDate() - adjustedDay + 1)
  // 计算本周的星期日
  const sunday = new Date(_date)
  sunday.setDate(_date.getDate() + (7 - adjustedDay))
  return {
    monday,
    sunday
  }
}

// 通用名字缩写
export const filterName = (name, num = 4, tag = '...') => {
  if (!name) {
    return ''
  } else if (name.length <= num) {
    return name
  } else {
    const _regex = `(.{${num - 2}})(.*)(.{1})`
    return name.replace(new RegExp(_regex), '$1' + tag + '$3')
  }
}

// 周几==对应数组位置 1，2，3，4，5，6，0
export const weekReflectArray = weekOrder => {
  return weekOrder === 0 ? 6 : weekOrder - 1
}

// 判断数据类型
export const typeofPro = obj => {
  /* eslint-disable */
  const type = typeof obj
  return type !== 'object'
    ? type
    : Object.prototype.toString

        .call(obj)
        .replace(/object |\[|]/gi, '')
        .toLowerCase()
  /* eslint-enable */
}

/**
 * 获取学期范围
 * @param {*} schoolYear
 * @returns
 */
export const getDateScope = schoolYear => {
  const firstMinDate = schoolYear + '-07-01'
  const firstMaxDate = timeFormat(
    new Date(
      new Date(schoolYear + 1 + '-03-01').getTime() - 24 * 60 * 60 * 1000
    ),
    'YYYY-MM-DD'
  )
  const secondMinDate = schoolYear + 1 + '-01-01'
  const secondMaxDate = schoolYear + 1 + '-08-31'
  return {
    firstMinDate,
    firstMaxDate,
    secondMinDate,
    secondMaxDate
  }
}

export const getDateScopeChore = schoolYear => {
  const firstMinDate = schoolYear + '-09-01'
  const firstMaxDate = schoolYear + 1 + '-01-31'

  const secondMinDate = schoolYear + 1 + '-02-01'
  const secondMaxDate = schoolYear + 1 + '-08-31'
  return {
    firstMinDate,
    firstMaxDate,
    secondMinDate,
    secondMaxDate
  }
}

export const getTermOrder = (currentDate, schoolYear) => {
  const { firstMinDate, firstMaxDate } = getDateScopeChore(schoolYear)
  if (
    (currentDate >= firstMinDate && currentDate <= firstMaxDate) ||
    currentDate < firstMinDate
  ) {
    return 1
  } else {
    return 2
  }
}

/**
 *
 * @param {Object} semesterSetting 学期设置
 * @param {Array} semesterList     两个学期的数据
 * @param {*} type 不传就是校验全部
 * @returns
 */
export const handlerJudge = (semesterSetting, semesterList, type) => {
  const { beforeYearEndDate, schoolYear } = semesterSetting
  const firstStartDimDay = semesterList[0].schoolTermStartDimDay
  const firstEndDimDay = semesterList[0].schoolTermEndDimDay
  const secondStartDimDay = semesterList[1].schoolTermStartDimDay
  const secondEndDimDay = semesterList[1].schoolTermEndDimDay
  const { firstMinDate, firstMaxDate, secondMinDate, secondMaxDate } =
    getDateScope(schoolYear)

  let message = ''
  let value = ''
  switch (type) {
    case '1-schoolTermStartDimDay':
      value = firstStartDimDay
      // 第一学期开始
      if (firstEndDimDay && value >= firstEndDimDay) {
        message = `结束日期必须大于开始日期`
      } else if (value < firstMinDate || value > firstMaxDate) {
        message = `第一学期时间范围${firstMinDate} ~ ${firstMaxDate}`
      } else if (value <= beforeYearEndDate) {
        message = `当前学期时间必须大于上一学年结束时间${beforeYearEndDate}`
      }
      break
    case '1-schoolTermEndDimDay':
      value = firstEndDimDay
      // 第一学期结束日期
      if (firstStartDimDay && firstStartDimDay >= value) {
        message = `结束日期必须大于开始日期`
      } else if (value < firstMinDate || value > firstMaxDate) {
        message = `第一学期时间范围${firstMinDate} ~ ${firstMaxDate}`
      } else if (value <= beforeYearEndDate) {
        message = `当前学期时间必须大于上一学年结束时间${beforeYearEndDate}`
      } else if (secondStartDimDay && value >= secondStartDimDay) {
        message = `当前学期时间不能和第二学期时间重合`
      }
      break
    case '2-schoolTermStartDimDay':
      value = secondStartDimDay
      // 第二学期开始日期
      if (secondEndDimDay && value >= secondEndDimDay) {
        message = `结束日期必须大于开始日期`
      } else if (value < secondMinDate || value > secondMaxDate) {
        message = `第二学期时间范围${secondMinDate} ~ ${secondMaxDate}`
      } else if (value <= beforeYearEndDate) {
        message = `当前学期时间必须大于上一学年结束时间${beforeYearEndDate}`
      } else if (value <= firstEndDimDay) {
        message = `第二学期时间必须大于第一学期结束时间${firstEndDimDay}`
      }
      break
    case '2-schoolTermEndDimDay':
      value = secondEndDimDay
      if (secondStartDimDay && secondStartDimDay >= value) {
        message = `结束日期必须大于开始日期`
      } else if (value < secondMinDate || value > secondMaxDate) {
        message = `第二学期时间范围${secondMinDate} ~ ${secondMaxDate}`
      } else if (value <= beforeYearEndDate) {
        message = `当前学期时间必须大于上一学年结束时间${beforeYearEndDate}`
      } else if (value <= firstEndDimDay) {
        message = `第二学期时间必须大于第一学期结束时间${firstEndDimDay}`
      }
      break
    default: // 空数据不校验
      // 开始时间不能大于等于结束时间
      // 第一学期不在时间段范围
      // 第二学期不在时间段范围
      // 某一个学期时间和上学年时间重合
      // 第二学期时间和上一学期时间有重合
      const case1 =
        !firstStartDimDay &&
        !firstEndDimDay &&
        !secondStartDimDay &&
        !secondEndDimDay

      const case2 =
        (firstStartDimDay &&
          firstEndDimDay &&
          firstStartDimDay >= firstEndDimDay) ||
        (secondStartDimDay &&
          secondEndDimDay &&
          secondStartDimDay >= secondEndDimDay)
      const case3 =
        (firstStartDimDay &&
          (firstStartDimDay < firstMinDate ||
            firstStartDimDay > firstMaxDate)) ||
        (firstEndDimDay &&
          (firstEndDimDay < firstMinDate || firstEndDimDay > firstMaxDate))

      const case4 =
        (secondStartDimDay &&
          (secondStartDimDay < secondMinDate ||
            secondStartDimDay > secondMaxDate)) ||
        (secondEndDimDay &&
          (secondEndDimDay < secondMinDate || secondEndDimDay > secondMaxDate))

      const case5 =
        (firstStartDimDay && firstStartDimDay <= beforeYearEndDate) ||
        (firstEndDimDay && firstEndDimDay <= beforeYearEndDate) ||
        (secondStartDimDay && secondStartDimDay <= beforeYearEndDate) ||
        (secondEndDimDay && secondEndDimDay <= beforeYearEndDate)

      const case6 =
        firstStartDimDay &&
        firstEndDimDay &&
        secondStartDimDay &&
        secondStartDimDay <= firstEndDimDay

      if (case1) {
        message = ''
      } else if (case2) {
        message = `结束日期必须大于开始日期`
      } else if (case3) {
        message = `第一学期时间范围${firstMinDate} ~ ${firstMaxDate}`
      } else if (case4) {
        message = `第二学期时间范围${secondMinDate} ~ ${secondMaxDate}`
      } else if (case5) {
        message = `当前学期时间必须大于上一学年结束时间${beforeYearEndDate}`
      } else if (case6) {
        message = `第二学期时间必须大于第一学期结束时间${firstEndDimDay}`
      }
      break
  }
  return message.replace(/-/g, '.')
}

export const handlerMessage = (semesterList, _order) => {
  const first = semesterList[0]
  const second = semesterList[1]
  let saveOther = false // 是否保存其他数据
  let message = ''
  let order = _order
  if (
    !first.schoolTermStartDimDay &&
    !first.schoolTermEndDimDay &&
    !second.schoolTermStartDimDay &&
    !second.schoolTermEndDimDay
  ) {
    message = '学期时间还未设置，请先设置'
  } else if (
    (first.schoolTermStartDimDay && !first.schoolTermEndDimDay) ||
    (!first.schoolTermStartDimDay && first.schoolTermEndDimDay)
  ) {
    // 任意一个学期只填写了起止时间或者结束时间直接报错
    message = `第一学期起止日期未设置，请先设置`
  } else if (
    (second.schoolTermStartDimDay && !second.schoolTermEndDimDay) ||
    (!second.schoolTermStartDimDay && second.schoolTermEndDimDay)
  ) {
    // 任意一个学期只填写了起止时间或者结束时间直接报错
    message = `第二学期起止日期未设置，请先设置`
  } else if (
    first.schoolTermStartDimDay &&
    first.schoolTermEndDimDay &&
    !second.schoolTermStartDimDay &&
    !second.schoolTermEndDimDay
  ) {
    // 第二学期没有任何设置
    order = 1
  } else if (
    !first.schoolTermStartDimDay &&
    !first.schoolTermEndDimDay &&
    second.schoolTermStartDimDay &&
    second.schoolTermEndDimDay
  ) {
    // 第一学期没有任何设置
    order = 2
  } else if (
    first.schoolTermStartDimDay &&
    first.schoolTermEndDimDay &&
    second.schoolTermStartDimDay &&
    second.schoolTermEndDimDay
  ) {
    order = 1
    saveOther = true // 两个学期都填写了 保存两个学期
  }
  return {
    order,
    saveOther,
    message
  }
}

// 数组去重
export const uniqueArray = (array, key) => {
  if (key) {
    return array.reduce((list, item) => {
      if (!list.some(kt => kt[key] === item[key])) {
        list = list.concat(item)
      }
      return list
    }, [])
  } else {
    let _unique = []
    for (let item of new Set(array).values()) {
      _unique.push(item)
    }
    return _unique
  }
}

/*  1: 魔点校园来源
 *  2: 魔方来源
 *  5: 健康防疫来源
 * 98: 微信公众号来源
 * 99: 网页魔点校园来源
 */
// 常规魔点校园
export const isNormalPlatform = () => {
  return getItem('platformSource') === '1'
}
// 魔方校园
export const isCubePlatform = () => {
  const platformSource = getItem('platformSource')
  return ['2', '5', '7', '8', '9', '12'].indexOf(`${platformSource}`) > -1
}

// 和教育
export const isHeEducationPlatform = () => {
  const platformSource = getItem('platformSource')
  return ['101'].indexOf(`${platformSource}`) > -1
}

// 网页版本魔点校园
export const isWebPlatform = () => {
  return ['98', '99'].includes(getItem('platformSource')) || IS_WEIXIN
}
// 微信公众号 魔点校园
export const isWxPlatform = () => {
  return getItem('platformSource') === '100' || IS_WEIXIN
}
export const showTitle = () => {
  return ['99'].includes(getItem('platformSource'))
}

export const getTitle = () => {
  const _platformSource = getItem('platformSource')
  // 定义在index.html
  // eslint-disable-next-line
  return PLATFORM_SOURCES[_platformSource] || PLATFORM_SOURCES[1]
}

export const getPageTitle = (to, defaultValue = true) => {
  const _meta = to.meta || {}
  return (
    (_meta.field
      ? (_meta.titleObj || {})[(to.query || {})[_meta.field]]
      : _meta.title) || (defaultValue ? getTitle() : '')
  )
}

export const startsWith = (str, searchvalue) => {
  if (str.startsWith) {
    return str.startsWith(searchvalue)
  }
  return str.indexOf(searchvalue) === 0
}

const fullPrefix = '/full'
const grayPrefix = '/gray'

export const getRoutePath = (path, type = 'all') => {
  if (type === 'all') {
    return {
      path: `${fullPrefix}${path}`,
      alias: `${grayPrefix}${path}`
    }
  }
  if (!['full', 'gray'].find(item => item === type)) {
    throw new Error('getRoutePath函数的type类型不正确！')
  }
  return {
    path: `/${type}${path}`
  }
}

/**
 * 路由列表 path 进行转换，转换为全量、灰度
 * @param {array} pathList 路由数组 可以传入 [{ path: '/full/index'}] 或者 [{ path: '/index'}]。path 以 /full 开头的已兼容，以 /gray 开头舍弃。pathType 不传, 默认生成全量与灰度、值为 full 或者 gray 则只生成对应的路由、keep 不转化 保持原样
 * @return array [ path: '/full/index', alias: '/gray/index', ... ]
 */
export const getRouteListPath = (pathList = []) => {
  return pathList
    .map(item => {
      let { path, pathType = 'all' } = item
      item.pathType && delete item.pathType
      if (pathType === 'keep') return item
      // 剔除灰度
      if (startsWith(path, grayPrefix)) return
      // 兼容全量
      if (startsWith(path, fullPrefix)) {
        path = path.split(fullPrefix)[1]
      }
      return { ...item, ...getRoutePath(path, pathType) }
    })
    .filter(item => !!item)
}

export const deptMaxName = deptName => {
  // 最多展示八个字 超过的 ...
  if (!deptName) {
    return ''
  }
  let _maxLen = 8
  let _len = deptName.length
  if (_len <= _maxLen) {
    return deptName
  }
  return `${deptName.slice(0, _maxLen - 1)}...`
}

export const calculateUniqueRole = params => {
  if (params && params === LEAVE_ROLE.classTeacher) {
    let { role } = getItem(TAB_ROLE_ID) || {}
    // 角色不存在或者存在多个角色
    if (!role || (role && String(role).indexOf(',') !== -1)) {
      let _topRole = getItem(TOP_ROLE_ID)
      let _roleIdList = getItem('roleIdList')
      role = _topRole || (_roleIdList && _roleIdList[0])
    }
    return +role
  } else {
    return params
  }
}

// 获取老师角色下 优先级最高的角色
export const getTeacherTopRole = role => {
  if (role !== LEAVE_ROLE.classTeacher) return role
  let _topRole = getItem(TOP_ROLE_ID)
  let _roleIdList = getItem('roleIdList')
  return _topRole || (_roleIdList && _roleIdList[0])
}

// 对当前角色为老师的进行处理
export function changeOperUserRoleTypes(params) {
  try {
    if (typeofPro(params) === 'object') {
      let _propertyList = [
        'operUserRoleTypes',
        'operUserRoleType',
        'roleType',
        'applicantRole'
      ]
      let _replaceProperty = Object.keys(params).find(
        item => !!_propertyList.find(v => v === item)
      )
      if (!_replaceProperty) return params
      if (
        String(params[_replaceProperty]) !== String(LEAVE_ROLE.classTeacher)
      ) {
        return params
      }
      let _roleIdList = getItem('roleIdList') || []
      // 老师角色下获取当前 TAB 对应的角色
      let { role } = getItem(TAB_ROLE_ID) || {}
      if (role) {
        let _moduleRoleMap = getItem(MODULE_ROLE_TYPE) || {}
        let { moduleType } = _moduleRoleMap
        // 模块首页，该模块不是全部替换的情况，均不进行角色合并
        if (
          _moduleRoleMap[getHash()] ||
          (moduleType && moduleType !== ROLE_REPLACE_TYPE.all)
        ) {
          // 去除可能重复的角色
          role = uniqueArray(String(role).split(','))
        } else {
          role = _roleIdList
        }

        params[_replaceProperty] = String(role)
      } else {
        let _topRole = getItem(TOP_ROLE_ID)
        let _role = _topRole || _roleIdList[0]
        if (_role) {
          params[_replaceProperty] = _role
        }
      }
    }
    return params
  } catch (error) {
    console.error(error, 'error')
    return params
  }
}

// 获取 hash 值
export function getHash() {
  let href = window.location.href
  const index = href.indexOf('#')
  // empty path
  if (index < 0) return ''
  href = href.slice(index + 1)
  return href
}

/**
 * @description 部分接口需要单独判断角色，与本地角色列表强关联，兼容模块权限校验
 * @param {Number} role 当前角色
 * @param {String} usedModule 在哪里模块使用
 * @param {Array} accessList 调整模块的权限范围,与 usedModule 连用
 * @return {Array}  返回合并之后角色列表
 */
export function getCombineRole(role, usedModule, accessList = []) {
  let _role = role
  let _roleIdList = getItem('roleIdList') || []

  if (role === LEAVE_ROLE.classTeacher) {
    // 老师角色下 直接取本地缓存
    _role = _roleIdList
  } else if (_roleIdList.includes(role)) {
    // 老师角色下，当前传递的角色有可能是已经解析过的
    _role = _roleIdList
  }
  let _isArray = typeofPro(_role) === 'array'

  // 如果存在模块限制，要根据模块能访问的角色，进行角色列表的删减
  if (_isArray && usedModule) {
    // 删除可能为空的角色
    accessList = accessList.filter(v => !!v)

    let _accessRoleMap = {
      // 德育
      moral: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.meTeacher,
        LEAVE_ROLE.teacher
      ],
      // 德育考评-自定义角色不能考评
      moralEvaluation: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.meTeacher,
        LEAVE_ROLE.teacher
      ],
      // 学生留堂
      detention: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.teacher],
      // 学生宿舍
      dorm: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.dormAdmin
      ],
      // 考勤
      attendance: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster
      ],
      // 通讯录
      addressList: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.teacher
      ],
      // 车辆管理
      vehiclemanage: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster
      ],
      // 校园安全
      security: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.security
      ],
      // 课堂行为
      behavior: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.behaviorTeacher
      ]
    }
    let _accessList = accessList.length
      ? accessList
      : _accessRoleMap[usedModule] || []

    _role = _role.filter(item => !!_accessList.includes(item))
  }
  // 默认返回数组
  _role = _isArray ? _role : String(role).split(',')

  return _role
}

/**
 * @description 老师分类下部分模块需要决出角色优先级，与本地角色列表强关联。
 * @param {Number} role 当前角色
 * @param {Array} accessList 模块的权限范围
 * @return {Number} 返回权限最高角色
 */
export function getModuleTopRole(role, accessList = []) {
  if (role !== LEAVE_ROLE.classTeacher) return role

  let _roleIdList = getItem('roleIdList') || []

  // 角色优先级
  return accessList.find(item => _roleIdList.includes(item))
}

export function pushNullUrl(url = document.URL) {
  window.history.pushState(null, null, url)
}

export function setLeft(callback) {
  if (typeof callback === 'function') {
    window.addEventListener('popstate', callback)
  }
}
export function removeLeft(callback) {
  if (typeof callback === 'function') {
    window.removeEventListener('popstate', callback)
  }
}

export const isDetectWebRTC = () => {
  const WEBRTC_CONSTANTS = [
    'RTCPeerConnection',
    'webkitRTCPeerConnection',
    'mozRTCPeerConnection',
    'RTCIceGatherer'
  ]

  const isWebRTCSupported = WEBRTC_CONSTANTS.find(item => {
    return item in window
  })

  const isGetUserMediaSupported =
    navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia

  if (!isWebRTCSupported || typeof isGetUserMediaSupported === 'undefined') {
    return false
  }
  return true
}

// 网页授权
// const redirectUrl = `https://wechat.moredian.com/views/code.html`
export const getUserThroughCode = () => {
  const link = window.location.href
  const callbackurl = encodeURIComponent(
    `${redirectUrl}?backUrl=${encodeURIComponent(link)}`
  )
  const appId = getSearchValueByKey('appId', window.location.hash)
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    appId || wechatAppId
  }&redirect_uri=${callbackurl}&response_type=code&scope=snsapi_userinfo&state=detail#wechat_redirect`
}

//  选择结果文本
export function resultText(selectedGroup = [], selectedUser = []) {
  let _text = ''
  if (!selectedGroup.length) {
    _text =
      (selectedUser.length <= 1
        ? (selectedUser[0] || {}).dingName
        : `${selectedUser.length}人`) || ''
  } else if (!selectedUser.length) {
    _text =
      (selectedGroup.length <= 1
        ? (selectedGroup[0] || {}).roleGroupName
        : `${selectedGroup.length}组`) || ''
  } else {
    _text = `${selectedGroup.length}组、${selectedUser.length}人`
  }
  return _text
}

export function copyText(text) {
  if (navigator.clipboard && IS_IOS) {
    // clipboard api 复制
    navigator.clipboard.writeText(text)
  } else {
    copy(text)
  }
}

// 判断人脸录入来源
export function enterFace(type = 0, corpId, role = 1, appId, other = '') {
  if (!type || typeof type !== 'number') {
    return false
  }
  // type 1: ding 2: cude
  const cubeFace = `https://mf-face.zjedu.com/link?direct=true&corpId=${corpId}`
  // devServId=56&source=devServId 钉钉给d2配置识别参数
  const dingFace = {
    1: `https://h5.dingtalk.com/facemanage/index.html?corpId=${corpId}&mainTask=true#/familyManage`,
    2: `https://h5.dingtalk.com/facemanage/index.html?showmen=false&mainTask=true&source=devServId&devServId=56&corpId=${corpId}&appId=${appId}${other}`,
    3: `https://h5.dingtalk.com/facemanage/index.html?showmen=false&mainTask=true&source=devServId&devServId=56&corpId=${corpId}&appId=${appId}`,
    5: `dingtalk://dingtalkclient/action/open_mini_app?ddMode=push&mainTask=true&miniAppId=5000000000119912&page=pages%2Fhome%2Fhome%3FisIsv%3Dtrue&query=corpId=${corpId}`
  }
  let faceUrl = ''
  switch (type) {
    case 1:
      faceUrl = dingFace[role]
      break
    case 2:
      faceUrl = cubeFace
      break
    case 3:
      faceUrl = `${gsUrl}/?corpId=${corpId}`
      break
  }
  return faceUrl
}

export const faceUrl = (orgId, dingUserId, operatorUserId) => {
  // auth: 授权码
  // orgId: 机构Id
  // id: 录脸人员Id
  // operatorId: 操作人员Id
  // mdType：ding（钉钉）、mp-wx（微信小程序）
  // pre：true || false  (未实现)
  // close: true || false  true: window.close()  false: history.back()
  // auth 获取方式：${magiccube-node}/custom/auth/code
  // ac: 授权确认 1: 授权 0: 不授权

  // orgUserId: '1770126335541248681'  orgId: '1770119291794882560'
  // https://yhibackstage.yhzaxy.yhbigdata.cn:8143/face/?orgId=1770119291794882560&id=1770126335541248681&operatorId=1770126335541248681&mdType=ding
  let url = `${apiHost}/face/?auth=${getItem(
    'faceauth'
  )}&orgId=${orgId}&id=${dingUserId}&operatorId=${operatorUserId}&mdType=ding&ac=0`
  console.log('------url-----', url)
  return url
}

// 去除前后空格
export const trim = str => {
  if (!str) {
    return ''
  }
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
/*
 * 获取当天、昨天、七天前
 * */
export function getMidnightDates(date = new Date()) {
  const yesterday = new Date(date)
  yesterday.setDate(yesterday.getDate() - 1)
  const sevenDaysAgo = new Date(date)
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

  const dates = [date, yesterday, sevenDaysAgo]
  const midnightDates = dates.map(d => {
    const year = d.getFullYear()
    const month = d.getMonth() + 1
    const day = d.getDate()
    // return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} 00:00:00`
    return `${year}${month.toString().padStart(2, '0')}${day
      .toString()
      .padStart(2, '0')}`
  })

  return midnightDates
}

export const formatDateFilter = dateStr => {
  const year = dateStr.substring(0, 4)
  const month = dateStr.substring(4, 6)
  const day = dateStr.substring(6, 8)

  const date = new Date(`${year}-${month}-${day}`)
  const options = { month: '2-digit', day: '2-digit', weekday: 'short' }
  return date.toLocaleDateString('zh-CN', options)
}

export const getTimeRanges = () => {
  const now = new Date()

  // 七天前的 0 点
  const sevenDaysAgo = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 7
  )

  // 昨天的 0 点
  const yesterdayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 1
  )

  // 今天的 0 点
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  // 第二天的 0 点
  const todayEnd = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1
  )

  return {
    sevenDaysAgo: {
      start: sevenDaysAgo.getTime(),
      end: todayEnd.getTime()
    },
    yesterday: {
      start: yesterdayStart.getTime(),
      end: todayStart.getTime()
    },
    today: {
      start: todayStart.getTime(),
      end: todayEnd.getTime()
    }
  }
}
export function getTimeRangeInMilliseconds(dateString) {
  const date = new Date(dateString)

  // 当天的 0 点
  const startOfDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  )

  // 第二天的 0 点
  const endOfDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + 1
  )

  return {
    start: startOfDay.getTime(),
    end: endOfDay.getTime()
  }
}

export function getTimestamps(date) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  // 当前日期的时间戳范围
  const todayStart = new Date(year, month, day)
  const todayEnd = new Date(year, month, day, 23, 59, 59, 999)
  const todayStartTimestamp = todayStart.getTime()
  const todayEndTimestamp = todayEnd.getTime()

  // 本年第几周的时间戳范围
  const firstDayOfYear = new Date(year, 0, 1)
  const dayOfYear = Math.ceil((date - firstDayOfYear) / 86400000)
  const weekNumber = Math.ceil((dayOfYear + firstDayOfYear.getDay() + 1) / 7)
  const weekStart = new Date(year, 0, 1 + (weekNumber - 1) * 7)
  const weekEnd = new Date(year, 0, 1 + weekNumber * 7 - 1, 23, 59, 59, 999)
  const weekStartTimestamp = weekStart.getTime()
  const weekEndTimestamp = weekEnd.getTime()

  // 本月第几个月的时间戳范围
  const firstDayOfMonth = new Date(year, month, 1)
  const lastDayOfMonth = new Date(year, month + 1, 0)
  const monthStartTimestamp = firstDayOfMonth.getTime()
  const monthEndTimestamp = new Date(
    lastDayOfMonth.getFullYear(),
    lastDayOfMonth.getMonth(),
    lastDayOfMonth.getDate(),
    23,
    59,
    59,
    999
  ).getTime()

  return [
    { start: todayStartTimestamp, end: todayEndTimestamp }, // 日
    { start: weekStartTimestamp, end: weekEndTimestamp }, // 周
    { start: monthStartTimestamp, end: monthEndTimestamp } // 月
  ]
}

export function getWeeksArray() {
  const weeksArray = []
  const currentDate = new Date() // 当前日期
  const currentYear = currentDate.getFullYear() // 当前年份
  let startDate = new Date(currentYear, 0, 1) // 当年第一天
  let week = 1

  // 如果当年的第一天不是星期日，则将起始日期调整为当年的第一个星期日
  // if (startDate.getDay() !== 0) {
  //   const firstSunday = 7 - startDate.getDay()
  //   startDate.setDate(1 + firstSunday)
  // }

  while (startDate <= currentDate) {
    const endDate = new Date(startDate)
    endDate.setDate(endDate.getDate() + 6) // 当前周的结束日期

    weeksArray.push({
      year: currentYear,
      week: week,
      startDay: timeFormat(startDate, 'YYYYMMDD'),
      endDay: timeFormat(endDate, 'YYYYMMDD'),
      name: `第${week}周（${timeFormat(
        new Date(startDate),
        'MM.DD'
      )} ~ ${timeFormat(new Date(endDate), 'MM.DD')}）`,
      value: week
    })

    const nextStartDate = new Date(startDate)
    nextStartDate.setDate(startDate.getDate() + 7) // 下一周的第一天
    startDate = nextStartDate
    week++
  }

  console.log(`weeksArray`, weeksArray)
  return weeksArray
}

export const disableDoubleClick = () => {
  // 监听所有元素的dblclick事件
  document.addEventListener(
    'dblclick',
    function (event) {
      event.preventDefault()
    },
    true
  ) // true表示在捕获阶段监听事件
}

export const checkTimeRangeRepeate = (timeList = []) => {
  // 将时间转为分钟数的函数
  const timeToMinutes = time => {
    const [hours, minutes] = time.split(':').map(Number)
    return hours * 60 + minutes
  }
  const _arr = timeList.map((item, index) => ({
    ...item,
    title: `时段${index + 1}`
  }))
  // 对数组按开始时间进行排序
  const sortedArr = _arr.sort(
    (a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime)
  )
  // 检查相邻时间段是否重叠，并返回最近的重叠项
  let overlappingItem = null
  for (let i = 0; i < sortedArr.length - 1; i++) {
    const currentEndTime = timeToMinutes(sortedArr[i].endTime)
    const nextStartTime = timeToMinutes(sortedArr[i + 1].startTime)

    if (currentEndTime > nextStartTime) {
      overlappingItem = {
        firstItem: sortedArr[i],
        secondItem: sortedArr[i + 1]
      }
      break
    }
  }
  return overlappingItem
}

export const combiTag = tags => {
  return [deepCopy(SEX_TAG), ...tags]
}

export const calStringLen = str => {
  return str.split('').reduce((total, char) => {
    // 判断字符是否为英文或数字
    if (/[a-zA-Z0-9]/.test(char)) {
      return total + 0.5
    } else {
      return total + 1
    }
  }, 0)
}

// 合并两个对象数组，按 id 去重，后者的属性覆盖前者
export const mergeJsonById = (arr1, arr2, id) => {
  const map = new Map()
  arr1.forEach(item => {
    if (`${item[id]}`) {
      map.set(`${item[id]}`, { ...item })
    }
  })
  arr2.forEach(item => {
    if (!`${item[id]}`) return
    const existing = map.get(`${item[id]}`)
    if (existing) {
      map.set(`${item[id]}`, { ...existing, ...item })
    } else {
      map.set(`${item[id]}`, { ...item })
    }
  })
  return Array.from(map.values())
}
